export const MOST_POPULAR_CERT_PROD = [9206658,
// social media marketing
9147496,
// inbound marketing
9206665,
// content marketing
9219103,
// digital marketing
9181866,
// inbound
9157909,
// SEO
9151245,
// email marketing
9147486,
// hubspot sales hub software
9147508,
// inbound sales
9219692,
// hubspot marketing hub software
9219107,
// digital advertising
9147503 // frictionless sales
];
export const MOST_POPULAR_CERT_IDS_QA = [407009, 1086900, 162428, 162778, 397673, 272481, 162869, 270706];
export const getPopularEnglishCerts = () => {
  if (window.enviro.isQa()) {
    return MOST_POPULAR_CERT_IDS_QA;
  } else {
    return MOST_POPULAR_CERT_PROD;
  }
};
export const RECOMMENDED_FOR = {
  9181866: ['inboundProfessionals', 'marketingProfessionals', 'salesProfessionals'],
  9206658: ['socialMediaMarketers', 'marketingProfessionals', 'aspiringMarketers'],
  9147496: ['inboundProfessionals', 'marketingProfessionals'],
  9206665: ['marketingProfessionals', 'inboundProfessionals', 'contentProducers'],
  9219103: ['marketingProfessionals', 'contentMarketers', 'aspiringMarketers'],
  9151245: ['marketingProfessionals'],
  9157909: ['marketingProfessionals', 'contentProducers'],
  9147508: ['salesProfessionals', 'salesManagers'],
  9219692: ['marketingProfessionals'],
  9147486: ['salesProfessionals', 'salesManagers'],
  9219107: ['marketingProfessionals', 'advertisingProfessionals'],
  36: ['salesManagers'],
  9147503: ['salesManagers', 'salesLeaders'],
  19: ['marketingManagers', 'salesManagers'],
  97: ['customerServiceManagers', 'customerServiceAgents'],
  87: ['marketingProfessionals', 'webDevelopers']
};